import baseApi from "./baseApi"
export default {
    /**
     * Fetch Plants, Divisions and Locations Data 
     * @return {Object} -- Plants, Divisions and Locations Data
     */
    async getSprayMasterData() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/spray/master");
        return result.data;
    },
    async addSpray(spray) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/spray/add", spray);
        return result.data;
    },
    async updateSpray(spray) {
        let request = await baseApi.createHttpRequest();
        let result = await request.put("/spray/update", spray);
        return result.data;
    },
    async deleteSpray(sprayID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.delete(`/spray/delete?sprayID=${sprayID}`);
        return result.data;
    },
    async batchProcessUnSyncedSpraies(unSyncedSpraies) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/spray/batch", unSyncedSpraies);
        return result.data;
    },
    async importSpray(file) {
        let request = await baseApi.createHttpRequest();
        let data = new FormData();
        console.log(file);
        data.set(JSON.stringify({
            FileName: file.FileName
        }), file.FileBlob);
        
        let result = await request.post("/spray/importspray", data, {
            headers: {
                "Content-Type": "multipart/form-data; boundary=" + data._boundary
            }
        });
        return result.data;
    }
}